import {
  UnitOfMeasurement,
  UnitOfMeasurementCode,
} from 'constants/unitOfMeasurement';
import { UnitsOfMeasurementModelType } from 'interfaces/unitOfMeasurement';

export const LIFE_SCIENCE_MAPPING: UnitsOfMeasurementModelType[] = [
  {
    key: 'typicalCeilingHeightFeet',
    config: {
      [UnitOfMeasurementCode.US]: {
        field: 'typicalCeilingHeightFeet',
        unit: UnitOfMeasurement.feet,
      },
      [UnitOfMeasurementCode.UK]: {
        field: 'typicalCeilingHeightMt',
        unit: UnitOfMeasurement.meter,
      },
      [UnitOfMeasurementCode.EU]: {
        field: 'typicalCeilingHeightMt',
        unit: UnitOfMeasurement.meter,
      },
    },
  },
  {
    key: 'typicalCeilingHeightInches',
    config: {
      [UnitOfMeasurementCode.US]: {
        field: 'typicalCeilingHeightInches',
        unit: UnitOfMeasurement.inches,
      },
      [UnitOfMeasurementCode.UK]: {
        field: 'typicalCeilingHeightMt',
        unit: UnitOfMeasurement.meter,
      },
      [UnitOfMeasurementCode.EU]: {
        field: 'typicalCeilingHeightMt',
        unit: UnitOfMeasurement.meter,
      },
    },
  },
];
